import { Box, CircularProgress, Typography } from '@mui/material';
import React from 'react';
import { useAnalysisStore } from '../../stores/analysisStore';
import O2kChartPanel from '../O2Kinetics/O2kChartPanel';

/**
 * O2KineticsGrid — responsive CSS Grid of O2kChartPanel components.
 * Same layout pattern as ChamberGrid, but renders editable O2K plots
 * where users can draw and manipulate transition windows.
 *
 * Only renders chambers that have data.
 */
const O2KineticsGrid = ({ tabId }) => {
  const tab = useAnalysisStore((state) => state.openFiles[tabId]);
  const isLoading = useAnalysisStore((state) => state.isLoading);

  if (!tab) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" sx={{ color: '#7d8d97' }}>
          No file data loaded
        </Typography>
      </Box>
    );
  }

  const chamberEntries = Object.entries(tab.chambers || {})
    .filter(([, ch]) => ch.data !== null)
    .sort(([a], [b]) => Number(a) - Number(b));

  if (isLoading && chamberEntries.length === 0) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <CircularProgress size={28} sx={{ color: '#394b57' }} />
      </Box>
    );
  }

  if (chamberEntries.length === 0) {
    return (
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100%' }}>
        <Typography variant="body2" sx={{ color: '#7d8d97' }}>
          No chamber data available for O₂ Kinetics
        </Typography>
      </Box>
    );
  }

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '8px',
        padding: '8px',
        height: '100%',
        overflow: 'auto',
      }}
    >
      {chamberEntries.map(([chamberIdx]) => (
        <Box
          key={`${tabId}-o2k-chamber-${chamberIdx}`}
          sx={{ width: '100%', height: '400px', flexShrink: 0 }}
        >
          <O2kChartPanel tabId={tabId} chamberIndex={Number(chamberIdx)} />
        </Box>
      ))}
    </Box>
  );
};

export default O2KineticsGrid;
